// extracted by mini-css-extract-plugin
module.exports = {"form":"SummaryAttributeViewerControl_form__3hdQe"};